type DimensionsTheme = {
  navbar: {
    width: number;
  };
  header: {
    height: number;
  };
  statusActionsBar: {
    height: number;
  };
  modal: {
    maxHeight: number;

    header: {
      height: number;
    };
    tabbar: {
      height: number;
    };
    toolbar: {
      height: number;
    };
    sidebar: {
      width: number;
    };
    footer: {
      height: number;
    };
  };
  dataGrid: {
    toolbar: {
      minHeight: number;
    };
    header: {
      twoLineTitleHeight: number;
    };
  };
};

declare module '@mui/material/styles' {
  interface Theme {
    dimensions: DimensionsTheme;
  }

  interface ThemeOptions {
    dimensions?: DimensionsTheme;
  }
}

// ----------------------------------------------------------------------

export const dimensions: DimensionsTheme = {
  navbar: {
    width: 88,
  },
  header: {
    height: 56,
  },
  statusActionsBar: {
    height: 56,
  },
  modal: {
    maxHeight: 944,

    header: {
      height: 56,
    },
    tabbar: {
      height: 48,
    },
    toolbar: {
      height: 56,
    },
    sidebar: {
      width: 400,
    },
    footer: {
      height: 68,
    },
  },
  dataGrid: {
    toolbar: {
      minHeight: 53,
    },
    header: {
      twoLineTitleHeight: 65,
    },
  },
};
